import React from 'react';

import type { TextComponent } from '../../../../../../core/data-sources/content-components/types.js';

import Text from './Text.js';
import { LinkWithPulse } from '../../../../../../core/mandatory-integrations/pulse/components/LinkWithPulse.js';
import { isTextBlock } from '../../../../../../core/data-sources/content-components/type-guards.js';

export interface TextWrapperProps {
  item: TextComponent;
  index: number;
  groupIndex: number;
}

const TextWrapper: React.FC<TextWrapperProps> = ({
  item,
  index,
  groupIndex,
}) => {
  const { presentationProperties, paragraphs } = item;

  if (presentationProperties?.telephone) {
    return (
      <LinkWithPulse
        href={`tel:${presentationProperties.telephone}`}
        key={`external-${index}-${groupIndex}`}
        className={`external-link telephone`}
        id="listicle-url-button"
        name="call phone button in listicle item"
        target="_blank"
      >
        Ring
      </LinkWithPulse>
    );
  }

  if (presentationProperties?.tag) {
    return (
      <div className="listicle-tag" key={`listicle-tag-${index}-${groupIndex}`}>
        <p>{isTextBlock(paragraphs[0]) && paragraphs[0]?.text?.value}</p>
        <h3 className="tag">{presentationProperties.tag} </h3>
      </div>
    );
  }

  return (
    <Text
      {...item}
      key={`text-${index}-${groupIndex}`}
      groupIndex={groupIndex}
    />
  );
};

export default TextWrapper;
